module.exports = __webpack_public_path__ + "img/vuetify-logo-dark.6e0c395a.png";